function setLinkName(this: HTMLInputElement) {
    const wrapper = this.closest('.js-contacts-link-wrapper');
    const nameContainer = wrapper?.querySelector('.js-contacts-link-name');
    const value = this.dataset.value;

    if (nameContainer && value) {
        nameContainer.textContent = value;
    }
}

function init(container: Element | Document = document) {
    const triggers = Array.from(container.querySelectorAll('.js-contacts-link-trigger'));

    triggers.forEach((input) => {
        input.addEventListener('change', setLinkName);
    });
}

function destroy(container: Element | Document = document) {
    const triggers = Array.from(container.querySelectorAll<HTMLElement>('.js-contacts-link-trigger'));

    triggers.forEach((input) => {
        input.removeEventListener('change', setLinkName);
    });
}

const module = { init, destroy };

export default module;
